import { motion } from "framer-motion";
import { FaEnvelope, FaMapMarkerAlt, FaHeart } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="relative bg-gradient-to-b from-gray-900 to-black text-gray-300 py-16 px-6 overflow-hidden">
      {/* Animated Floating Blobs */}
      <motion.div
        animate={{ x: [0, 30, -30, 0], rotate: [0, 15, -15, 0] }}
        transition={{ repeat: Infinity, duration: 10, ease: "easeInOut" }}
        className="absolute top-0 left-0 w-32 h-32 bg-blue-500/20 blur-2xl rounded-full"
      />
      <motion.div
        animate={{ y: [0, -30, 30, 0], rotate: [0, -15, 15, 0] }}
        transition={{ repeat: Infinity, duration: 12, ease: "easeInOut" }}
        className="absolute bottom-0 right-0 w-24 h-24 bg-pink-500/20 blur-2xl rounded-full"
      />

      {/* Glass Footer Container */}
      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-8">
        {/* Top Row: Brand + Tagline */}
        <div className="text-center space-y-4 mb-12">
          <h2 className="text-4xl font-extrabold bg-gradient-to-r from-blue-400 to-cyan-300 bg-clip-text text-transparent drop-shadow-md">
            Vcode Freelance
          </h2>
          <p className="text-lg text-gray-300">
            Your Vision, Our Code — <span className="text-white font-semibold">Seamless. Scalable. Secure.</span>
          </p>
        </div>

        {/* Middle Row: Glass Info Panel */}
        <div className="bg-white/5 border border-white/10 backdrop-blur-md rounded-3xl px-6 py-10 grid grid-cols-1 md:grid-cols-3 gap-10 text-center shadow-2xl">
          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-blue-300">Quick Links</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="#home" className="hover:text-white transition">Home</a></li>
              <li><a href="#services" className="hover:text-white transition">Services</a></li>
              <li><a href="#portfolio" className="hover:text-white transition">Projects</a></li>
              <li><a href="#contact" className="hover:text-white transition">Contact</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-green-300">Contact Us</h3>
            <div className="flex justify-center items-center gap-2 text-sm text-gray-300">
              <FaEnvelope className="text-blue-400" />
              <a href="mailto:info.vcodefreelance@gmail.com" className="hover:text-white transition">
                info.vcodefreelance@gmail.com
              </a>
            </div>
            <div className="flex justify-center items-center gap-2 text-sm text-gray-300">
              <FaMapMarkerAlt className="text-red-400" />
              <span>Coimbatore, Tamil Nadu, India</span>
            </div>
          </div>

          {/* Credits */}
          <div className="flex flex-col justify-center items-center gap-3">
            <p className="text-sm text-gray-400 text-center max-w-xs">
              Crafted with passion & purpose by the{" "}
              <span className="text-pink-300 font-semibold">Vcode Team</span>.
            </p>
            <div className="flex items-center gap-2 text-gray-500">
              <span>Made with</span>
              <FaHeart className="text-red-500 animate-pulse" />
              <span>by Vcode</span>
            </div>
          </div>
        </div>

        {/* Bottom Row: Copyright */}
        <div className="mt-10 text-center text-sm text-gray-500 border-t border-white/10 pt-6">
          &copy; {new Date().getFullYear()} Vcode Freelance. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
